import { environment } from './../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  API: string = environment.baseURL;

  constructor(private httpClient: HttpClient) {}

  public getOrders(data): Observable<any> {
    return this.httpClient.post(`${this.API}/getOrderSet`, data);
  }

  public getOrderDetails(id: string, network: string): Observable<any> {
    return this.httpClient.post( `${this.API}/getOrderDetail`, {id: id, network: network});
  }

  public getProductDetails(id: string, network: string): Observable<any> {
    return this.httpClient.post( `${this.API}/getProductDetail`, {id: id, network: network, includeClientReview: false});
  }

  public cancelOrder(id: number, network: string, PROVIDER_REFUSAL: string, action: string, textareaMessage: string): Observable<any> {
    return this.httpClient.post(`${this.API}/cancelOrder`, {id: id, network: network, errorCode: PROVIDER_REFUSAL, action: action, message: textareaMessage});
  }

  public paymentOrderAccepted(id: number, network: string): Observable<any> {
    return this.httpClient.post(`${this.API}/acceptOrder`, {id: id, network: network});
  }

  // public paymentOrderRefused(id: number, PAYMENT_NOT_RECEIVED: string): Observable<any> {
  //   return this.httpClient.post(`${this.API}/cancelOrder`, {id: id, errorCode: PAYMENT_NOT_RECEIVED});
  // }

  public orderCompleted(id: number, network: string): Observable<any> {
    return this.httpClient.post(`${this.API}/finishOrder`, {id: id, network: network});
  }

  public orderBlocageUsine(id: number, network: string, PROVIDER_REFUSAL: string, textareaMessage: string): Observable<any> {
    return this.httpClient.post(`${this.API}/blocageUsine`, {id: id, network: network, errorCode: PROVIDER_REFUSAL, message: textareaMessage});
  }

  public orderBlocageMetrage(id: number, network: string, PROVIDER_REFUSAL: string, textareaMessage: string): Observable<any> {
    return this.httpClient.post(`${this.API}/blocageMetrage`, {id: id, network: network, errorCode: PROVIDER_REFUSAL, message: textareaMessage});
  }

  public orderSent(id: number, network: string): Observable<any> {
    return this.httpClient.post(`${this.API}/sentOrder`, {id: id, network: network});
  }

  public optionsLabels(config: any): Observable<any> {
    return this.httpClient.post(`${this.API}/options-labels/getProductRecapFromConfig`, config);
  }

  public setupEstimationDates(id: number, network: string, estimateStart: Date, estimateEnd: Date, typeEstimation: string ): Observable<any> {
    const request = {
      id: id,
      network: network,
      estimateStart: estimateStart,
      estimateEnd: estimateEnd,
      sendEmail: true,
      typeEstimation: typeEstimation
    };
    return this.httpClient.post(`${this.API}/estimateOrder`, request);
  }

  public deleteOrder(id: number, network: string): Observable<any> {
    return this.httpClient.post(`${this.API}/deleteOrder`, {id: id, network: network});
  }

  public getProductPrice(data: object): Observable<any> {
    return this.httpClient.post(`${this.API}/getProductPrice`, data);
  }
}
